(function () {
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Animate children of elements marked as data-animate="children"
          if (entry.target.dataset.animate === "children") {
            const animChildren = entry.target.querySelectorAll(
              ":scope > *:not([data-animate='false'])"
            );
            animChildren.forEach((child, i) => {
              child.style.setProperty("--delay", `${i * 450}ms`);
              child.classList.add("is-visible");
            });
          }

          // Animate element itself if data-animate="true"
          if (entry.target.dataset.animate === "true") {
            entry.target.classList.add("is-visible");
          }

          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

  // Watch all scroll-triggered elements
  document
    .querySelectorAll("[data-animate='children'], [data-animate='true']")
    .forEach((el) => observer.observe(el));

  // Load-triggered animations (fire immediately on page load, no scroll needed)
  function triggerLoadAnimations() {
    // Stagger children
    document.querySelectorAll("[data-animate='load-children']").forEach((el) => {
      const children = el.querySelectorAll(":scope > *:not([data-animate='false'])");
      children.forEach((child, i) => {
        child.style.setProperty("--delay", `${i * 150}ms`);
        child.classList.add("is-visible");
      });
    });

    // Single elements
    document.querySelectorAll("[data-animate='load']").forEach((el) => {
      el.classList.add("is-visible");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", triggerLoadAnimations);
  } else {
    triggerLoadAnimations();
  }
})();
